module.exports = __webpack_public_path__ + "static/media/google.695a3160.svg";